<template>
  <v-dialog v-model="dialog" max-width="450" v-on:click:outside="toggleDialog">
    <v-card :min-width="400" style="padding: 20px">
      <v-menu
        ref="menu"
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateDeb"
            label="Date début"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-on:click:date="menu1 = false"
          ref="picker"
          v-model="dateDeb"
          :max="new Date().toISOString().substr(0, 10)"
          min="1950-01-01"
        ></v-date-picker>
      </v-menu>
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFin"
            label="Date fin"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          :allowed-dates="allowedDatesEnd"
          v-on:click:date="menu2 = false"
          ref="picker"
          v-model="dateFin"
          :max="new Date().toISOString().substr(0, 10)"
          min="1950-01-01"
        ></v-date-picker>
      </v-menu>
      <v-card-actions
        style="display: flex; padding: 10px; justify-content: center"
      >
        <v-btn color="blue" dark @click.prevent="save">Enregistrer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  mounted() {
    this.dateDeb = this.startDate;
    this.dateFin = this.endDate;
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      dateDeb: "",
      dateFin: ""
    };
  },
  props: {
    dialog: { type: Boolean, default: false },
    toggleDialog: { type: Function },
    request: { type: Object }
  },
  watch: {
    request() {
      this.dateDeb = this.startDate;
      this.dateFin = this.endDate;
    }
  },
  methods: {
    allowedDatesEnd(val) {
      const date = new Date(val);
      const start = new Date(this.dateDeb);

      return date.getTime() > start.getTime();
    },

    save() {
      const { dates } = this.request;
      const start = new Date(this.dateDeb);
      const end = new Date(this.dateFin);
      dates[0].from = start.getTime();
      dates[0].to = end.getTime();
      this.$services.absenceRequest.update(this.request);
      this.$root.$emit("refresh");
      this.toggleDialog();
    }
  },
  computed: {
    startDate() {
      if (this.request.dates) {
        const date = new Date();
        date.setTime(this.request.dates[0].from);
        return `${date.getFullYear()}-${
          date.getMonth() + 1 < 10
            ? `0${date.getMonth() + 1}`
            : date.getMonth() + 1
        }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
      }
    },
    endDate() {
      if (this.request.dates) {
        const date = new Date();
        date.setTime(this.request.dates[0].to);
        return `${date.getFullYear()}-${
          date.getMonth() + 1 < 10
            ? `0${date.getMonth() + 1}`
            : date.getMonth() + 1
        }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
      }
    }
  }
};
</script>

<style></style>
